import React from 'react';
import Navbar from './Navbar';
import { useAlerts } from '../../context/AlertContext';
import AlertModal from '../alerts/AlertModal';
import '../../styles/layout.css';

const Layout = ({ children }) => {
  const { alertsToShow, clearAlertsToShow, dismissRecentAlert, soundEnabled } = useAlerts();

  const handleCloseModal = () => {
    alertsToShow.forEach(a => dismissRecentAlert(a.id));
    clearAlertsToShow();
  };

  return (
    <div className="page-layout">
      <Navbar />

      <main className="page-main">
        <div className="page-container">
          {children}
        </div>
      </main>

      {/* Alert Modal - shown when new critical alerts detected */}
      {alertsToShow.length > 0 && (
        <AlertModal
          alerts={alertsToShow}
          onClose={handleCloseModal}
          playSound={soundEnabled}
        />
      )}
    </div>
  );
};

export default Layout;

